import { AbstractControl, Validators } from '@angular/forms';

const validatorFn = Validators.pattern(/^[a-zA-Z0-9]*$/);

export function ValidateAlphanumeric(control: AbstractControl) {
  const err = validatorFn(control);
  return err ? { alphanumeric: true } : null;
}
